var _style, _path, _line, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigViuzz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 841.9",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{opacity:0.25;fill:none;}\n\t.st2{opacity:0.25;fill:url(#SVGID_2_);enable-background:new    ;}\n\t.st3{opacity:0.25;fill:url(#SVGID_3_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4824,
    y1: 593.5612,
    x2: 970.1625,
    y2: -520.8967,
    gradientTransform: "matrix(1 0 0 -1 0 842.1891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1024e-7,
    style: {
      stopColor: "#F08316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    style: {
      stopColor: "#E62F26"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.1,824.7c2.3-2.4,4.6-4.9,6.9-7.3c0.1-0.2,0.2-0.3,0.3-0.4c13.7-14.8,27-30,39.8-45.5 c35.1-42.5,66.9-87.8,95-135.4c7.1-12,14-24.2,20.6-36.5c0-0.1,0.1-0.1,0.1-0.2c-0.5-7.9-1.1-15.7-1.8-23.6 c-11-131.1-46.2-255.5-101.2-368.6c0,0,0,0-0.1-0.1c-1.2-2.5-2.4-5-3.7-7.5c-0.5-1.1-1.1-2.2-1.6-3.3c-1.2-2.3-2.5-4.5-3.9-6.7 c-0.1-0.1-0.1-0.3-0.2-0.3c-12.9-19.7-34-33.9-59.3-37.2c-46.3-6.3-88.8,26.2-95,72.4c-1.8,13.7-0.3,27,4,39.2 c0,0.1,0.1,0.2,0.1,0.3c1.2,2.5,2.3,4.9,3.4,7.5c0.9,1.7,1.6,3.5,2.3,5.3c0.1,0.1,0.1,0.3,0.2,0.4c1.9,4.1,3.7,8.3,5.5,12.5 c1.1,2.5,2.1,5.1,3.2,7.7c1.9,4.3,3.6,8.6,5.3,13c0.4,0.9,0.8,1.9,1.2,2.9c2.1,5.3,4.2,10.7,6.3,16.1c0.3,0.7,0.5,1.3,0.7,2 c2.1,5.5,4.2,11.1,6.2,16.7c0.5,1.4,1,2.9,1.5,4.3c2,5.7,4,11.5,5.9,17.3c1.5,4.6,3,9.2,4.5,13.8c1.4,4.1,2.7,8.3,3.9,12.5 c1.7,5.3,3.2,10.7,4.7,16.1c1.6,5.4,3.1,10.9,4.6,16.4c1.2,4.3,2.3,8.5,3.3,12.7c1,3.7,1.9,7.3,2.8,11c2.5,10.3,4.9,20.6,7.1,31 c0.7,3.3,1.5,6.7,2.1,10c1.1,5.1,2.1,10.2,3.1,15.4c20,106,23.7,216.9,8.9,329.6c-0.2,1.5-0.4,2.2-0.6,3.7c0.3,0,0.3,0,0.6,0h0.6 h0.6c3.3-8.6,5.6-9.4,11.8-16.9C226.9,824.9,227,824.7,227.1,824.7z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 595.4,
    y1: 255.3,
    x2: 595.4,
    y2: 257.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1013.9626,
    y1: 1091.9602,
    x2: -1040.3802,
    y2: -1886.839,
    gradientTransform: "matrix(1 0 0 -1 0 841.9688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6714,
    style: {
      stopColor: "#F08316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E62F26"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.4,221.7c0-53.9,0-66.7,0-66.7c-40.3-2.5-82.4,35-88,72.6c0,0.2-0.1,0.6-0.1,0.9c-0.2,1.1-0.3,2.3-0.4,3.5 c-15.4,125.5-53.2,244.9-109.7,353.7c-2.4,4.6-4.7,9.2-7.2,13.7c0,0.1-0.1,0.1-0.1,0.2c-6.6,12.3-13.5,24.5-20.6,36.5 c-28.1,47.6-59.9,92.9-95,135.4c-12.8,15.5-26.1,30.7-39.8,45.5c-0.1,0.1-0.2,0.2-0.3,0.4c-2.3,2.4-4.6,4.9-6.9,7.3 c-0.1,0-0.2,0.2-0.3,0.3c-6.2,7.5-8.5,8.3-11.8,16.9l0,0c0,0,14.4,0,24.3,0c50.1,0,68.3,0,82.7,0c2-0.1,37.5,0,37.5,0 c23.5,0,29.2,0,34.6,0c2,0,39.1,0,53.6,0c129.2-177,147.7-255.2,147.7-255.2s0-279.6,0-323.2v-5.4 C594.6,268.6,594.6,221.5,594.4,221.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.3998,
    y1: 760.4889,
    x2: 480.4,
    y2: 760.4889,
    gradientTransform: "matrix(1 0 0 -1 0 842.1891)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    style: {
      stopColor: "#F08316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E62F26"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M404.4,157.7c42,0,76-34,76-76s-34-76-76-76s-76,34-76,76C328.3,123.6,362.4,157.7,404.4,157.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigViuzz);
export default __webpack_public_path__ + "static/media/bigViuzz.7c15f342dc9bb3b3b56615dfd3e0fb87.svg";
export { ForwardRef as ReactComponent };